import pic02 from './assets/anabiya.png';
import pic03 from './assets/arafa.png';
import pic04 from './assets/aidon.png';
import pic05 from './assets/grocery.png';
import pic06 from './assets/ecommerce.png';
import pic07 from './assets/tn.png';
import icon02 from './assets/smallSize/anabiya.png';
import icon03 from './assets/smallSize/arafa.png';
import icon04 from './assets/smallSize/aidon.png';
import icon05 from './assets/smallSize/grocery.png';
import icon06 from './assets/smallSize/ecommerce.png';
import icon08 from './assets/smallSize/t_toll.png';
import pic08 from './assets/t_toll.png';
import icon09 from './assets/smallSize/gtrack_D.png';
import pic09 from './assets/gtrack_D.png';
import pic10 from './assets/gtrack.png';
import icon10 from './assets/smallSize/gtrack.png';
import pic11 from './assets/raena.png';
import icon11 from './assets/smallSize/raena.png';

export const works = [
  {
    id: 1,
    title: '',
    image: pic08,
    icon: icon08,
    link: '',
    live: 'https://think-toll.netlify.app/',
  },

  {
    title: '',
    image: pic11,
    icon: icon11,
    link: '',
    live: 'https://www.raenabeauty.com/id-en/',
  },

  {
    title: '',
    image: pic09,
    icon: icon09,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },
  {
    title: '',
    image: pic10,
    icon: icon10,
    link: '',
    live: 'https://gateway.thinkiotcore.com/',
  },

  {
    id: 3,
    title: '',
    image: pic03,
    icon: icon03,
    live: 'https://sayeemarafa.netlify.app/',
  },
  {
    id: 4,
    title: '',
    image: pic04,
    icon: icon04,
    link: '',
    live: 'https://sayeemaidon.netlify.app/',
  },
  {
    id: 5,
    title: '',
    image: pic05,
    icon: icon05,
    link: '',
    live: 'https://sayeemgrocery.netlify.app/',
  },
  {
    id: 2,
    title: '',
    image: pic02,
    icon: icon02,
    link: '',
    live: 'https://sayeemyanabiya.netlify.app/',
  },
  {
    id: 6,
    title: '',
    image: pic06,
    icon: icon06,
    link: '',
    live: 'https://sayeemecommerce.netlify.app/',
  },
  {
    id: 7,
    title: '',
    image: pic07,
    icon: pic07,
    link: '',
    live: 'https://sayeemtn.netlify.app/',
  },
];
